export const curtains = "https://storage.googleapis.com/public_viteslink_storage/images/invitation02/curtain.png";
export const flower01Url = "https://storage.googleapis.com/public_viteslink_storage/images/invitation02/flower01.png";
export const flower02Url = "https://storage.googleapis.com/public_viteslink_storage/images/invitation02/flower02.png";
export const waive01 = "https://storage.googleapis.com/public_viteslink_storage/images/invitation02/waive.png";
export const waive02 = "https://storage.googleapis.com/public_viteslink_storage/images/invitation02/waive02.png";
export const barakAllah = "https://storage.googleapis.com/public_viteslink_storage/images/invitation02/barak_allah.svg";
export const instagramIcon =
	"https://storage.googleapis.com/public_viteslink_storage/images/invitation02/instagramIcon.png";
export const commentFrame =
	"https://storage.googleapis.com/public_viteslink_storage/images/invitation02/comment_frame.png";
